<template>
    <div class="criar-espacos-form">
        <!-- Loading -->
        <loading />

        <form
            @submit.prevent="sendData(routine)"
            class="form-module admin-backoffice-form"
            method="post"
            action=""
            aria-describedby="Create Customer Card Plans"
            enctype="application/x-www-form-urlencoded"
            autocomplete="on"
        >
            <!-- Detalhes do espaço -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Detalhes do espaço</legend>

                    <!-- Name -->
                    <div class="input-row-item">
                        <div data-reference="name" class="item-label-input">
                            <label
                                for="name"
                                class="form-label body-1 strong-600"
                                >Nome*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('name')"
                                @focusout="inputValidationCase('name')"
                                v-model="name"
                                class="form-control"
                                id="name"
                                placeholder="Nome"
                                maxlength="150"
                            />
                        </div>
                        <small v-if="routine === 'PUT'">
                            <span>Marketing url: </span> {{ `${customData.plpurl}${moduleData[0].slug}` }}
                        </small>
                    </div>

                    <!-- Location -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">
                            Localização*
                        </h3>

                        <template v-if="customData.locations.length > 0">
                            <ul class="selected-list location-list">
                                <li
                                    v-for="(
                                        value, index
                                    ) in customData.locations"
                                    :key="value.id"
                                    :data-refereindex="index"
                                    :data-id="value.id"
                                    data-indicate="location"
                                    @click="
                                        chooseItems(
                                            $event,
                                            locationsSelected,
                                            customData.locations
                                        )
                                    "
                                    class="list-group-item location-list-group-item"
                                >
                                    <span
                                        :data-refereindex="index"
                                        :data-id="value.id"
                                        data-indicate="location"
                                        class="body-1"
                                        >{{ value.name }}</span
                                    >
                                    <span class="caption-md color-text-body">
                                        {{
                                            `${value.address}, ${value.complement} | ${value.postalcode}`
                                        }}
                                    </span>
                                </li>
                            </ul>
                        </template>
                    </div>

                    <!-- Address -->
                    <!-- 
                        <div class="input-row-item">
                            <div data-reference="address" class="item-label-input">
                                <label
                                    for="address"
                                    class="form-label body-1 strong-600"
                                    >Morada*</label
                                >
                                <input
                                    type="text"
                                    @focusin="inputValidationCase('address')"
                                    @focusout="inputValidationCase('address')"
                                    v-model="address"
                                    class="form-control"
                                    id="address"
                                    placeholder="Morada"
                                    maxlength="350"
                                />
                            </div>
                        </div>
                     -->

                    <!-- Postalcode -->
                    <!-- 
                        <div class="input-row-item">
                            <div
                                data-reference="postalcode"
                                class="item-label-input"
                            >
                                <label
                                    for="postalcode"
                                    class="form-label body-1 strong-600"
                                    >Código Postal*</label
                                >
                                <input
                                    type="text"
                                    @focusin="inputValidationCase('postalcode')"
                                    @focusout="inputValidationCase('postalcode')"
                                    v-model="postalcode"
                                    class="form-control"
                                    id="postalcode"
                                    placeholder="Código Postal"
                                    maxlength="12"
                                />
                            </div>
                        </div>
                     -->

                    <!-- Complemento -->
                    <!-- 
                        <div class="input-row-item">
                            <div
                                data-reference="complement"
                                class="item-label-input"
                            >
                                <label
                                    for="complement"
                                    class="form-label body-1 strong-600"
                                    >Complemento</label
                                >
                                <input
                                    type="text"
                                    @focusin="inputValidationCase('complement')"
                                    @focusout="inputValidationCase('complement')"
                                    v-model="complement"
                                    class="form-control"
                                    id="complement"
                                    placeholder="Complemento"
                                    maxlength="150"
                                />
                            </div>
                        </div>
                     -->
                </fieldset>
            </div>

            <!-- Reserva e preço -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Reserva e preço</legend>

                    <!-- Tipo de reserva -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">
                            Tipo de reserva*
                        </h3>

                        <div class="form-check-wrapper">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="unique_reservation"
                                    value="1"
                                    type="radio"
                                    name="uniqueReservation"
                                    id="unique_reservation_yes"
                                    :checked="
                                        unique_reservation === 1 ? true : false
                                    "
                                />
                                <label
                                    class="form-check-label"
                                    for="unique_reservation_yes"
                                >
                                    <span class="button-body"
                                        >Reserva hóraria</span
                                    ><span class="caption-md color-text-body"
                                        >Mínimo 1 hora</span
                                    >
                                </label>
                            </div>

                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="unique_reservation"
                                    value="2"
                                    type="radio"
                                    name="uniqueReservation"
                                    id="unique_reservation_no"
                                    :checked="
                                        unique_reservation === 2 ? true : false
                                    "
                                />
                                <label
                                    class="form-check-label"
                                    for="unique_reservation_no"
                                >
                                    <span class="button-body"
                                        >Reserva periódica</span
                                    ><span class="caption-md color-text-body">{{
                                        `Das ${turnMorning.begin}:00 às ${turnMorning.end}:00 ou às ${turnAfternoon.begin}:00 às ${turnAfternoon.end}:00`
                                    }}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Disponibilidade do espaço  -->
                    <!-- 
                        <div class="input-row-item">
                            <h3 class="body-1 strong-600 item-title">
                                Disponibilidade do espaço*
                            </h3>

                            <div class="form-check-wrapper">
                                <div class="form-check form-check-availability">
                                    <input
                                        class="form-check-input"
                                        v-model="periodic_reserve"
                                        value="1"
                                        type="radio"
                                        name="periodicReservation"
                                        id="periodic_reservation_morning"
                                        :checked="
                                            periodic_reserve === 1 ? true : false
                                        "
                                    />
                                    <label
                                        class="form-check-label"
                                        for="periodic_reservation_morning"
                                    >
                                        Manhã
                                    </label>
                                </div>
                                <div class="form-check form-check-availability">
                                    <input
                                        class="form-check-input"
                                        v-model="periodic_reserve"
                                        value="2"
                                        type="radio"
                                        name="periodicReservation"
                                        id="periodic_reservation_afternoon"
                                        :checked="
                                            periodic_reserve === 2 ? true : false
                                        "
                                    />
                                    <label
                                        class="form-check-label"
                                        for="periodic_reservation_afternoon"
                                    >
                                        Tarde
                                    </label>
                                </div>
                                <div class="form-check form-check-availability">
                                    <input
                                        class="form-check-input"
                                        v-model="periodic_reserve"
                                        value="3"
                                        type="radio"
                                        name="periodicReservation"
                                        id="periodic_reservation_both"
                                        :checked="
                                            periodic_reserve === 3 ? true : false
                                        "
                                    />
                                    <label
                                        class="form-check-label"
                                        for="periodic_reservation_both"
                                    >
                                        Ambos
                                    </label>
                                </div>
                            </div>
                        </div>
                     -->

                    <!-- Preço -->
                    <div class="input-row-item">
                        <div
                            data-reference="hourvalue"
                            class="item-label-input"
                        >
                            <label
                                for="hourvalue"
                                class="form-label body-1 strong-600"
                                >Preço*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('hourvalue')"
                                @focusout="inputValidationCase('hourvalue')"
                                v-model="hourvalue"
                                class="form-control"
                                id="hourvalue"
                                placeholder="0.00"
                                maxlength="6"
                            />
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Horários -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Horários</legend>

                    <!-- Close Days -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">
                            Dia(s) encerrado(s)
                        </h3>

                        <template v-if="week.length > 0">
                            <ul class="selected-list week-list">
                                <li
                                    v-for="(value, index) in week"
                                    :key="value.id"
                                    :data-refereindex="index"
                                    :data-id="value.id"
                                    data-indicate="accessorie"
                                    @click="
                                        chooseItems(
                                            $event,
                                            weekdaysSelected,
                                            week
                                        )
                                    "
                                    class="list-group-item"
                                >
                                    <span
                                        :data-refereindex="index"
                                        :data-id="value.id"
                                        data-indicate="accessorie"
                                        class="body-1"
                                        >{{ value.shortVersion }}</span
                                    >
                                </li>
                            </ul>
                        </template>
                    </div>

                    <!-- Clean Hour -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">
                            Horário de Limpeza
                            <span class="caption-md color-text-body">
                                ( hh:mm )</span
                            >
                        </h3>

                        <div class="clean-hour-wrapper">
                            <div
                                data-reference="clean_start"
                                class="relative cleaning-start"
                            >
                                <label for="clean_start" class="form-label"
                                    >Inicio*</label
                                >
                                <span class="hour-icon"></span>

                                <input
                                    type="text"
                                    @focusin="
                                        inputValidationCase('clean_start')
                                    "
                                    @focusout="
                                        inputValidationCase('clean_start')
                                    "
                                    v-model="clean_start"
                                    class="form-control"
                                    id="clean_start"
                                    placeholder="Inicio"
                                    maxlength="5"
                                />
                            </div>

                            <div
                                data-reference="clean_end"
                                class="relative cleaning-end"
                            >
                                <label for="clean_end" class="form-label"
                                    >Fim*</label
                                >

                                <span class="hour-icon"></span>

                                <input
                                    type="text"
                                    @focusin="inputValidationCase('clean_end')"
                                    @focusout="inputValidationCase('clean_end')"
                                    v-model="clean_end"
                                    class="form-control"
                                    id="clean_end"
                                    placeholder="Fim"
                                    maxlength="5"
                                />
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Informação extra -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Informação extra</legend>

                    <!-- Categories -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">Categoria*</h3>

                        <template v-if="customData.categories.length > 0">
                            <ul class="selected-list categories-list">
                                <li
                                    v-for="(
                                        value, index
                                    ) in customData.categories"
                                    :key="value.id"
                                    :data-refereindex="index"
                                    :data-id="value.id"
                                    data-indicate="categorie"
                                    @click="
                                        chooseItems(
                                            $event,
                                            categoriesSelected,
                                            customData.categories
                                        )
                                    "
                                    class="list-group-item"
                                >
                                    <span
                                        :data-refereindex="index"
                                        :data-id="value.id"
                                        data-indicate="categorie"
                                        :class="[
                                            'categories-icon',
                                            'body-1',
                                            value.icon
                                                ? `icone-${value.icon}`
                                                : 'icone-other',
                                        ]"
                                        >{{ value.name }}</span
                                    >
                                </li>
                            </ul>
                        </template>
                    </div>

                    <!-- Accessories -->
                    <div class="input-row-item">
                        <h3 class="body-1 strong-600 item-title">
                            Acessorios*
                        </h3>

                        <template v-if="customData.accessories.length > 0">
                            <ul class="selected-list accessories-list">
                                <li
                                    v-for="(
                                        value, index
                                    ) in customData.accessories"
                                    :key="value.id"
                                    :data-refereindex="index"
                                    :data-id="value.id"
                                    data-indicate="accessorie"
                                    @click="
                                        chooseItems(
                                            $event,
                                            accessoriesSelected,
                                            customData.accessories
                                        )
                                    "
                                    class="list-group-item"
                                >
                                    <span
                                        :data-refereindex="index"
                                        :data-id="value.id"
                                        data-indicate="accessorie"
                                        :class="[
                                            'accessorie-icon',
                                            'body-1',
                                            `icone-${value.data.icon}`,
                                        ]"
                                        >{{ value.name }}</span
                                    >
                                </li>
                            </ul>
                        </template>
                    </div>

                    <!-- Description -->
                    <div class="input-row-item">
                        <div
                            data-reference="description"
                            class="item-label-input"
                        >
                            <label
                                for="description"
                                class="form-label body-1 strong-600"
                                >Descrição</label
                            >
                            <textarea
                                class="form-control"
                                @focusin="inputValidationCase('description')"
                                @focusout="inputValidationCase('description')"
                                v-model="description"
                                placeholder="Descreva o espaço"
                                id="description"
                                maxlength="400"
                            >
                            </textarea>
                        </div>
                    </div>

                    <!-- Rules of User -->
                    <div class="input-row-item">
                        <div
                            data-reference="rulesofuse"
                            class="item-label-input"
                        >
                            <label
                                for="rulesofuse"
                                class="form-label body-1 strong-600"
                                >Regras de Uso</label
                            >
                            <textarea
                                class="form-control"
                                @focusin="inputValidationCase('rulesofuse')"
                                @focusout="inputValidationCase('rulesofuse')"
                                v-model="rulesofuse"
                                placeholder="Regras de utilização do espaço"
                                id="rulesofuse"
                                maxlength="400"
                            >
                            </textarea>
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Informação extra -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Media</legend>
                    <!-- Images -->
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <h3 class="body-1 strong-600">Imagens*</h3>
                            <div class="baseimage_preview"></div>
                            <div class="custom-file-upload">
                                <label
                                    for="accessorie_image"
                                    class="custom-file-label"
                                >
                                    <span class="button-body color-text-action"
                                        >Adicionar Imagem</span
                                    >
                                </label>

                                <input
                                    @change="
                                        multipleFileData(
                                            $event,
                                            'accessorie_image'
                                        )
                                    "
                                    class="input-file-account"
                                    name="files"
                                    type="file"
                                    id="accessorie_image"
                                    accept="image/*"
                                    ref="accessorie_image"
                                    data-filealt="accessorie_image"
                                    multiple
                                />
                            </div>

                            <!-- <input
                                @change="
                                    multipleFileData($event, 'accessorie_image')
                                "
                                class="form-control input-file-account"
                                name="files"
                                type="file"
                                id="accessorie_image"
                                accept="image/*"
                                ref="accessorie_image"
                                data-filealt="accessorie_image"
                                multiple
                            /> -->
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Submit Button -->
            <div class="input-row">
                <button
                    type="submit"
                    class="btn btn-primary btnsubmit button-body"
                    :disabled="disabled"
                >
                    {{ routine === "PUT" ? "Editar espaço" : "Criar espaço" }}
                </button>

                <button
                    @click="turnBack(moduledefaultindex)"
                    type="button"
                    class="btn btncancel button-body"
                >
                    Cancelar
                </button>
            </div>
        </form>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>

<script>
import fetchData from "./../../../fetchData.js";
import htmlElements from "./../../../htmlElements";
import inputValidation from "./../../../validationInputs.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";
import responseMessage from "./../../../responseMessage.js";

//Set Use Strict
("use strict");

export default {
    name: "OfficesForm",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routine: {
            type: String,
            required: true,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: Array,
            required: true,
        },
        customdata: {
            type: Object,
            required: false,
        },
        imgdefaultaccount: {
            type: String,
            required: false,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            name: "",
            description: "",
            hourvalue: "",
            address: "",
            postalcode: "",
            complement: "",
            rulesofuse: "",
            customData: [],
            clean_start: "",
            clean_end: "",
            unique_reservation: 1,
            periodic_reserve: 3,
            categoriesSelected: [],
            accessoriesSelected: [],
            locationsSelected: [],
            weekdaysSelected: [],
            disabled: true,
            inputNotIsValid: true,
            activeclass: "d-flex",
            moduleData: [],
            alertmegabyte: 1024 * 1000 * 1.2,
            filedataformlist: [],
            filedataformitemlist: {},
            filewidthheightlist: [],
            filedataformlistMediaData: [],
            week: [
                {
                    id: 0,
                    name: "Domingo",
                    shortVersion: "Domingo",
                },
                {
                    id: 1,
                    name: "Segunda-Feira",
                    shortVersion: "Segunda",
                },
                {
                    id: 2,
                    name: "Terça-Feira",
                    shortVersion: "Terça",
                },
                {
                    id: 3,
                    name: "Quarta-Feira",
                    shortVersion: "Quarta",
                },
                {
                    id: 4,
                    name: "Quinta-Feira",
                    shortVersion: "Quinta",
                },
                {
                    id: 5,
                    name: "Sexta-Feira",
                    shortVersion: "Sexta",
                },
                {
                    id: 6,
                    name: "Sábado",
                    shortVersion: "Sábado",
                },
            ],
            quantityofimages: 10,
            turnMorning: {},
            turnAfternoon: {},
            responseTimeOut: 5000,
        };
    },
    created() {
        //Set Module Data
        this.moduleData = this.moduledata;

        //Set Custom Data
        this.customData = this.customdata;
        this.turnMorning = this.customData.typeofreservation.turns.find(
            (value) => value.id === 1
        );
        this.turnAfternoon = this.customData.typeofreservation.turns.find(
            (value) => value.id === 2
        );
    },
    mounted() {
        //Set Values for Update Routine
        this.setValuesForUpdate(this.moduleData);

        /* window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        }); */
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        turnBack(referurl) {
            defaultWebsite.turnBack(referurl);
        },
        chooseItems(element, selectedlist, referlist) {
            //Get Data from element
            let referElement = element.currentTarget;

            //Get Refer Index
            let referIndex = parseInt(
                referElement.getAttribute("data-refereindex")
            );

            //Enabled Button
            this.disabled = false;

            //Add Class and Push
            if (selectedlist.length === 0) {
                //Push Element
                selectedlist.push(referlist[referIndex]);

                //Selected
                referElement.classList.add("selected");
            } else {
                //Get Id
                let id = parseInt(referElement.getAttribute("data-id"));

                //Get Value from referList
                let indicateValue = selectedlist.find(
                    (value) => value.id === id
                );

                //Get Index
                let indexValue = "";

                if (indicateValue === undefined) {
                    //Check Type of List
                    switch (referElement.getAttribute("data-indicate")) {
                        //Location
                        case "location":
                            //Get Parent Element
                            let referElementList = referElement.parentElement;

                            //Remove all selected class
                            [...referElementList.children].forEach((val) =>
                                val.classList.remove("selected")
                            );

                            //Get Index
                            selectedlist.forEach(
                                (value, index) => (indexValue = index)
                            );

                            //Remove from List
                            selectedlist.splice(indexValue, 1);

                            //Push Element
                            selectedlist.push(referlist[referIndex]);

                            //Selected
                            referElement.classList.add("selected");

                            break;

                        //Categorie, Accessorie
                        case "categorie":
                        case "accessorie":
                            //Push Element
                            selectedlist.push(referlist[referIndex]);

                            //Selected
                            referElement.classList.add("selected");

                            break;
                    }
                } else {
                    //Get Index
                    selectedlist.forEach((value, index) => {
                        if (value.id === id) {
                            indexValue = index;
                        }
                    });

                    //Remove from List
                    selectedlist.splice(indexValue, 1);

                    //Unselected
                    referElement.classList.remove("selected");
                }
            }
        },
        inputValidationCase(inputid) {
            //console.log(Object.entries(this.$data));

            //Check Inputs
            switch (inputid) {
                //name
                case "name":
                    this.disabled = inputValidation.validNameCases(4, this.name)
                        ? false
                        : true;

                    break;

                //hourvalue
                case "hourvalue":
                    this.disabled = inputValidation.validNameCases(
                        13,
                        this.hourvalue.trim()
                    )
                        ? false
                        : true;

                    break;

                //address
                case "address":
                    this.disabled = inputValidation.validNameCases(
                        4,
                        this.address
                    )
                        ? false
                        : true;

                    break;

                //postalcode
                case "postalcode":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        this.postalcode
                    )
                        ? false
                        : true;

                    break;

                //complement
                case "complement":
                    if (this.complement !== "") {
                        this.disabled = inputValidation.validNameCases(
                            11,
                            this.complement
                        )
                            ? false
                            : true;
                    }

                    break;

                //description
                case "description":
                    if (
                        this.description !== "" ||
                        this.description.length <= 400
                    ) {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.description
                        )
                            ? false
                            : true;
                    }

                    break;

                //rulesofuse
                case "rulesofuse":
                    if (
                        this.rulesofuse !== "" ||
                        this.rulesofuse.length <= 400
                    ) {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.rulesofuse
                        )
                            ? false
                            : true;
                    }

                    break;

                //clean_start
                case "clean_start":
                    this.disabled = inputValidation.validNameCases(
                        14,
                        this.clean_start
                    )
                        ? false
                        : true;

                    break;

                //clean_end
                case "clean_end":
                    this.disabled = inputValidation.validNameCases(
                        14,
                        this.clean_end
                    )
                        ? false
                        : true;

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        setValuesForUpdate(moduleData) {
            //Check Routine
            if (this.routine === "POST") {
                return;
            }

            //Set Value
            this.name = moduleData[0].name;
            this.hourvalue = moduleData[0].value.replace("€", "").trim();

            //Set Selected Item
            this.setUpdateValuesPerList(
                "location",
                "location-list",
                moduleData[0].location_id,
                this.locationsSelected,
                this.customData.locations
            );
            this.setUpdateValuesPerList(
                "categories",
                "categories-list",
                moduleData[0].category_id,
                this.categoriesSelected,
                this.customData.categories
            );

            //Check Acessorie
            if (moduleData[0].accessorie_id !== null) {
                this.setUpdateValuesPerList(
                    "accessories",
                    "accessories-list",
                    moduleData[0].accessorie_id,
                    this.accessoriesSelected,
                    this.customData.accessories
                );
            }

            //Check Rule
            if (moduleData[0].rule !== null) {
                //Get Rule data
                let rules = JSON.parse(moduleData[0].rule[0]);

                //Set Rule data
                this.clean_start = rules.clean.start;
                this.clean_end = rules.clean.end;
                this.setUpdateValuesPerList(
                    "week",
                    "week-list",
                    rules.weekdayclose,
                    this.weekdaysSelected,
                    this.week
                );
                this.unique_reservation =
                    rules.typeofreservation.unique_reservation;
                this.periodic_reserve =
                    rules.typeofreservation.periodic_reserve;
            }

            //Check Data
            if (moduleData[0].data !== null) {
                //List of Inputs
                let inputList = [
                    "address",
                    "complement",
                    "postalcode",
                    "description",
                    "rulesofuse",
                ];

                //Set Update Values
                inputList.forEach((value) => {
                    if (
                        Object.hasOwn(moduleData[0].data, value) &&
                        Object.hasOwn(this.$data, value)
                    ) {
                        //Get Value
                        let updateData = Object.getOwnPropertyDescriptor(
                            moduleData[0].data,
                            value
                        );

                        //Set Value
                        this.$data[value] = updateData.value;
                    }
                });
            }

            //Check by Media Data
            if (Array.isArray(moduleData[0].media_id)) {
                moduleData[0].media_data.forEach((value, index) => {
                    //Create Image
                    let img = this.createImage(`preview_${index}`);

                    //Set src
                    img.setAttribute(
                        "src",
                        value[0].thumbexist
                            ? value[0].media_thumb
                            : value[0].media_original
                    );

                    //Set Preview Image Content
                    document
                        .querySelector(".baseimage_preview")
                        .appendChild(img);
                });
            }

            //Set Conditional
            this.inputNotIsValid = false;

            //Enabled Submit Button
            this.disabled = false;
        },
        setUpdateValuesPerList(
            indicate,
            list,
            updatevalue,
            selectList,
            referList
        ) {
            //Check Indicate
            switch (indicate) {
                case "location":
                    //Set Selected Item
                    [...document.querySelector(`.${list}`).children].forEach(
                        function (value) {
                            if (
                                parseInt(value.getAttribute("data-id")) ===
                                updatevalue
                            ) {
                                //Add selected class
                                value.classList.add("selected");
                            }
                        }
                    );

                    //Push Value
                    selectList.push(
                        referList.find((val) => val.id === updatevalue)
                    );

                    break;

                case "categories":
                case "accessories":
                case "week":
                    //Check List
                    if (!Array.isArray(updatevalue)) {
                        return;
                    }

                    //Set Selected Item
                    [...document.querySelector(`.${list}`).children].forEach(
                        function (value) {
                            updatevalue.forEach((val) => {
                                if (
                                    Object.is(
                                        val.id,
                                        parseInt(value.getAttribute("data-id"))
                                    )
                                ) {
                                    //Push Value
                                    selectList.push(val);

                                    //Add selected class
                                    value.classList.add("selected");
                                }
                            });
                        }
                    );

                    break;
            }
        },
        createImage(inputid, height = "76", width = "auto") {
            //Create LI Element
            return htmlElements.createElement("img", {
                class: `preview_${inputid} img-preview-item`,
                id: `preview_${inputid}`,
                src: "",
                height: height,
                width: width,
                alt: "preview",
                style: "object-fit: cover;",
            });
        },
        multipleFileData(element, inputid) {
            //Check Routine
            if (this.routine === "PUT") {
                //Send Confirmation
                let confirmChangeImg = confirm(
                    "Ao mudar as imagens irá remover as antigas. Deseja Proceder ?"
                );

                //Check Confirmation
                if (!confirmChangeImg) {
                    return;
                }
            }

            //Set Disabled
            element.target.setAttribute("disabled", true);

            //FileData Item Object Clean Variable
            this.filedataformitemlist = {};
            this.filewidthheightlist = [];
            this.filedataformlist = [];

            //Clean Old Preview Images
            [...document.querySelector(".baseimage_preview").children].forEach(
                (value) => value.remove()
            );

            //Get Data from File
            let filedata = element.target.files;

            //Check quantity of files
            if (filedata.length >= this.quantityofimages) {
                alert(
                    "Nosso sistema apenas permite até 10 imagens por upload."
                );

                //Enabled Input
                element.target.removeAttribute("disabled");

                return;
            }

            //Get Data from Multiple File
            [...filedata].forEach((value, index) => {
                //Check fileSize
                if (value.size >= Math.abs(this.alertmegabyte)) {
                    alert("Please upload a smaller file up to 1MG");

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    //Disabled Submit button
                    //this.disabled = true;

                    return;
                }

                //Check type of the file
                if (!value.type.includes("image")) {
                    alert("Please only send image type file");

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    return;
                }

                //Structure File Data Object
                this.filedataformitemlist = {
                    fileindex: index,
                    filename: value.name.trim(),
                    filedata: {},
                };

                //Create Image Element
                let img = this.createImage(inputid + "_" + index);

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (e) => {
                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                        //Set FileDimension
                        let filedimension = {
                            width: img.width,
                            height: img.height,
                        };

                        //Set File width and height
                        this.filewidthheightlist.push(filedimension);

                        return this.filewidthheightlist;
                    };

                    img.onerror = (error) => {
                        throw new Error(error);
                    };

                    img.src = src;
                };

                //Create Event Listenner for render image
                reader.addEventListener(
                    "load",
                    () => {
                        // convert image file to base64 string
                        img.src = reader.result;

                        //Set Preview Image Content
                        document
                            .querySelector(".baseimage_preview")
                            .appendChild(img);
                    },
                    false
                );

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(value);

                //Get Data from Promise
                this.filedataformitemlist.filedata = file64Promise
                    .then((val64) => {
                        //Structure File Data Object
                        let filedata = {
                            type: value.type.replace("image/", ""),
                            filealt: value.name.trim(),
                            file64: val64,
                            filename: value.name.trim(),
                        };

                        //Check Old Image Data and remove old image data
                        //this.oldImageUpdateRoutine(element.target.getAttribute('data-storeid'), this.filedataformitemlist.filedata);

                        //Remove Disabled Attribute
                        element.target.removeAttribute("disabled");

                        //Send Data for Storage File
                        return filedata;
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });

                //Push Data
                this.filedataformlist.push(this.filedataformitemlist);
            });

            //Check FileData
            if (this.filedataformlist.length > 0) {
                this.filedataformlist.forEach((value, index) => {
                    //Set Filedimension
                    this.filedataformlist[index].filedimension =
                        this.filewidthheightlist[index];

                    //Get FileData from Promise
                    value.filedata
                        .then((valfile) => {
                            //Replace Object
                            this.filedataformlist[index].filedata = valfile;
                        })
                        .catch((error) => {
                            throw new Error(error);
                        });
                });
            }

            //Enabled Button
            this.disabled = false;
        },
        oldImageUpdateRoutine(storeid, newimgdata) {
            //Check Old Image Data
            if (
                this.routine === "PUT" &&
                this.filedataformlistMediaData.length > 0
            ) {
                //Index old image
                //let indexOldImg = null;

                this.filedataformlistMediaData.forEach(
                    (valoldimg, indexoldimg) => {
                        if (valoldimg.media.store_id === parseInt(storeid)) {
                            //indexOldImg = indexoldimg;

                            //Update FileData
                            valoldimg.filedata.newimg = newimgdata;
                        }
                    }
                );

                /* if(indexOldImg !== null){

                    //Remove old data from FileData
                    this.filedataformlistMediaData.splice(indexOldImg, 1);

                } */
            }
        },
        sendData(method) {
            //When the input is empty
            if (
                this.name === "" ||
                this.hourvalue === "" ||
                this.clean_start === "" ||
                this.clean_end === "" ||
                this.categoriesSelected.length === 0 ||
                /* this.filedataformlist.length === 0 || */
                this.locationsSelected.length === 0
            ) {
                
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Todos os campos com * são de preenchimento obrigatório",
                    this.activeclass
                );

                this.disabled = true;

                return;
            }

            //Create a float number
            let hourValue = parseFloat(this.hourvalue.trim());

            //Check Hour Value Datatype
            if (this.hourvalue !== "" && Number.isNaN(hourValue)) {
           
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Necessário informar dados válidos para o campo Preço",
                    this.activeclass
                );

                this.disabled = true;

                return;
            }

            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            let dataForm = {
                name: this.name.trim(),
                value: hourValue.toString(),
                address:
                    this.locationsSelected.length > 0
                        ? this.locationsSelected[0].address
                        : null,
                postalcode:
                    this.locationsSelected.length > 0
                        ? this.locationsSelected[0].postalcode
                        : null,
                complement:
                    this.locationsSelected.length > 0
                        ? this.locationsSelected[0].complement
                        : null,
                rulesofuse:
                    this.rulesofuse !== "" ? this.rulesofuse.trim() : null,
                description:
                    this.description !== "" ? this.description.trim() : null,
                filedata:
                    this.filedataformlist.length > 0
                        ? this.filedataformlist
                        : null,
                location_id:
                    this.locationsSelected.length > 0
                        ? this.locationsSelected[0].id
                        : null,
                category_id:
                    this.categoriesSelected.length > 0
                        ? this.categoriesSelected
                        : null,
                accessorie_id:
                    this.accessoriesSelected.length > 0
                        ? this.accessoriesSelected
                        : null,
                rule: {
                    clean: {
                        start: this.clean_start,
                        end: this.clean_end,
                    },
                    weekdayclose: this.weekdaysSelected,
                    typeofreservation: {
                        unique_reservation: parseInt(this.unique_reservation),
                        periodic_reserve: parseInt(this.periodic_reserve),
                    },
                },
            };

            //Check Routine
            if (this.routine === "PUT") {
                dataForm.id = this.moduleData[0].id;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                dataForm,
                this.csrftolken,
                this.routine
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Check Response
                    if (Object.is(value.classname, "success")) {
                        //Redirect for Module Index
                        window.location.replace(this.moduleindex);
                    }

                    //Enabled Button
                    this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedDisabled() {
            return this.disabled;
        },
        computedInputIsNotValid() {
            return this.inputNotIsValid;
        },
        computedFiledataFormList() {
            return this.filedataformlist;
        },
        computedFileFormItemList() {
            return this.filedataformitemlist;
        },
        computedFileWidthHeightList() {
            return this.filewidthheightlist;
        },
        computedCategoriesSelected() {
            return this.categoriesSelected;
        },
        computedAccessoriesSelected() {
            return this.accessoriesSelected;
        },
        computedLocationsSelected() {
            return this.locationsSelected;
        },
        computedWeekDaysSelected() {
            return this.weekdaysSelected;
        },
    },
    watch: {
        computedDisabled() {},
        computedInputIsNotValid() {},
        computedFiledataFormList() {},
        computedFileFormItemList() {},
        computedFileWidthHeightList() {},
        computedCategoriesSelected() {},
        computedAccessoriesSelected() {},
        computedLocationsSelected() {},
        computedWeekDaysSelected() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        cardElement: CardElement,
    },
    beforeDestroy() {
        this.name = "";
        this.address = "";
        this.postalcode = "";
        this.complement = "";
        this.observation = "";
        this.user_rule = "";
    },
};
</script>
